import get from 'lodash/get'
import kebabCase from 'lodash/kebabCase'
import set from 'lodash/set'
import { useContext, useMemo } from 'react'

import { ampli } from '@Analytics/ampli'
import { BlockContext } from '@Globals/CMS/Context'

export function useAmplitude({ sourceID }: { sourceID?: string } = {}) {
  const { blockID, blockType, id } = useContext(BlockContext)
  const source = sourceID || id

  const result = useMemo(() => {
    const normalizedBlockType = kebabCase(blockType || '').replace('-block', '')
    return new Proxy(ampli, {
      get(target, property) {
        const value = Reflect.get(target, property)

        if (typeof value !== 'function') {
          return value
        }

        return function wrappedTarget(...args) {
          if (get(args, '[0].source_id') === 'inherit') {
            set(args, '[0].source_id', source)
          }

          if (blockID) {
            set(args, '[0].src_block_id', blockID)
          }

          if (normalizedBlockType) {
            set(args, '[0].src_block_type', normalizedBlockType)
          }

          return value.bind(target)(...args)
        }
      },
    })
  }, [blockID, blockType, source])

  return result
}
